function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Button, Select, Alert, InputNumber, Modal, Switch, Radio, Drawer } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { Upload as UploadIc, DoorOpenFill, PersonVcardFill, Building, TelephoneFill, GeoAltFill, CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import { Icon } from "@iconify/react";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import HospitalizationDepositReceipt from "../HospitalizationDepositReceipt";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;

var Admission = function Admission(_ref) {
  var handler = _ref.handler;

  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      companyOptions = _useState8[0],
      setCompanyOptions = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      rooms = _useState10[0],
      setRooms = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      beds = _useState12[0],
      setBeds = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      companies = _useState14[0],
      setCompanies = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      isNewPatient = _useState16[0],
      setIsNewPatient = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      rdata = _useState18[0],
      setRdata = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isDataChanged = _useState20[0],
      setIsDataChanged = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showReceipt = _useState22[0],
      setShowReceipt = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      depositAmount = _useState24[0],
      setDepositAmount = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      patient = _useState26[0],
      setPatient = _useState26[1];

  var _useState27 = useState([]),
      _useState28 = _slicedToArray(_useState27, 2),
      allBeds = _useState28[0],
      setAllBeds = _useState28[1];

  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

  var onCompanyChanged = function onCompanyChanged(v) {};

  var onFinish = function onFinish(values) {
    confirm({
      type: "warning",
      title: /*#__PURE__*/_jsx("b", {
        children: "Attention"
      }),
      content: isNewPatient == 1 ? /*#__PURE__*/_jsxs("p", {
        children: ["Veuillez confirmer le num\xE9ro de t\xE9l\xE9phone ", /*#__PURE__*/_jsx("b", {
          children: values.mobile
        }), " avant de valider."]
      }) : /*#__PURE__*/_jsxs("p", {
        children: ["Veuillez confirmer l'ID du patient ", /*#__PURE__*/_jsx("b", {
          children: values.idnumber
        }), " avant de valider."]
      }),
      okText: "Valider",
      cancelText: "Annuler",
      onOk: function onOk() {
        executeAdmission(values);
      }
    });
  };

  var executeAdmission = function executeAdmission(values) {
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('job', values.job);
    formData.append('birthdate', values.birthdate);
    formData.append('company_id', values.company_id);
    formData.append('mobile', values.mobile);
    formData.append("address", values.address);
    formData.append('gender', values.gender);
    formData.append("bed_id", values.bed_id);
    formData.append("idnumber", values.idnumber);
    formData.append("deposit", values.deposit);
    formData.append("isNewPatient", isNewPatient);
    formData.append("user_id", Common.currentUser.id);
    setErrorMessage('');
    setSuccessMessage('');
    axios.post(Common.baseApiUrl + 'admitpatient', formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setPatient(response.data.patient);
        setDepositAmount(values.deposit);
        form.resetFields();
        setShowReceipt(true);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    setCompanyOptions([{
      value: 0,
      label: 'Aucune prise en charge'
    }]);
    axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompanies(response.data.companyList);
        response.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }

      form.setFieldsValue({
        gender: 'F',
        category: 0,
        company_id: 0
      });
    })["catch"](function (error) {});
  }, []);
  useEffect(function () {
    setIsDataChanged(false);
    axios.get(Common.baseApiUrl + 'getrooms/' + Common.currentUser.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        setRooms([]);

        if (response.data.rooms.length > 0) {
          response.data.rooms.forEach(function (e) {
            setRooms(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: e.id,
                label: e.label
              }]);
            });
            e.beds.forEach(function (b) {
              setAllBeds(function (prev) {
                return [].concat(_toConsumableArray(prev), [b]);
              });
            });
          });
          form.setFieldsValue({
            room_id: response.data.rooms[0].id
          });
          response.data.rooms[0].beds.forEach(function (e) {
            setBeds(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: e.id,
                label: e.label,
                room_id: e.room_id
              }]);
            });
          });
        }
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      padding: "14px",
      borderRadius: "7px",
      background: "#FFFFFF"
    },
    children: [/*#__PURE__*/_jsxs("fieldset", {
      children: [/*#__PURE__*/_jsx("legend", {
        children: "Fiche d'admission"
      }), /*#__PURE__*/_jsxs(Form, {
        layout: "vertical",
        onFinish: onFinish,
        form: form,
        children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Alert, {
            message: errorMessage,
            type: "error",
            showIcon: true
          })
        }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Alert, {
            message: successMessage,
            type: "success",
            showIcon: true
          })
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 12,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Nouveau patient",
              children: /*#__PURE__*/_jsx(Switch, {
                onChange: function onChange(v) {
                  if (v == true) setIsNewPatient(1);else setIsNewPatient(0);
                },
                size: "default",
                checked: isNewPatient == 1,
                checkedChildren: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                unCheckedChildren: /*#__PURE__*/_jsx(XCircleFill, {})
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 12,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "ID Patient",
              name: "idnumber",
              rules: [{
                required: isNewPatient == 0,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                disabled: isNewPatient == 1,
                size: "large"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Montant caution",
              name: "deposit",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                size: "large",
                suffix: "GNF",
                style: {
                  width: "180px"
                },
                formatter: function formatter(value) {
                  return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                }
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Salle",
              name: "room_id",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Select, {
                onChange: function onChange(v) {
                  setBeds([]);
                  var b = allBeds.filter(function (b) {
                    return b.room_id == v;
                  });
                  b.forEach(function (b) {
                    setBeds(function (prev) {
                      return [].concat(_toConsumableArray(prev), [{
                        value: b.id,
                        label: b.label
                      }]);
                    });
                  });
                },
                prefix: /*#__PURE__*/_jsx(DoorOpenFill, {}),
                defaultActiveFirstOption: true,
                placeholder: "Choisir la salle",
                optionLabelProp: "label",
                optionFilterProp: "label",
                filterOption: function filterOption(input, option) {
                  return option.label.toLowerCase().includes(input.toLowerCase());
                },
                showSearch: true,
                options: rooms
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Lit",
              name: "bed_id",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Select, {
                onChange: function onChange() {},
                prefix: /*#__PURE__*/_jsx(Icon, {
                  icon: "medical-icon:i-inpatient"
                }),
                defaultActiveFirstOption: true,
                placeholder: "Choisir le lit",
                optionLabelProp: "label",
                optionFilterProp: "label",
                filterOption: function filterOption(input, option) {
                  return option.label.toLowerCase().includes(input.toLowerCase());
                },
                showSearch: true,
                options: beds
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "firstname",
              label: "Pr\xE9nom",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                disabled: isNewPatient == 0,
                prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "lastname",
              label: "Nom",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                disabled: isNewPatient == 0,
                prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Age",
              name: "birthdate",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                disabled: isNewPatient == 0,
                suffix: "Ans"
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "job",
              label: "Profession",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                disabled: isNewPatient == 0,
                prefix: /*#__PURE__*/_jsx(Building, {})
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "gender",
              label: "Genre",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                disabled: isNewPatient == 0,
                options: [{
                  label: 'Homme',
                  value: 'H'
                }, {
                  label: 'Femme',
                  value: 'F'
                }],
                optionType: "button",
                buttonStyle: "solid"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "mobile",
              label: "T\xE9l\xE9phone",
              rules: [{
                required: isNewPatient == 1,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                disabled: isNewPatient == 0,
                prefix: /*#__PURE__*/_jsx(TelephoneFill, {})
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "company_id",
              children: /*#__PURE__*/_jsx(Select, {
                onChange: onCompanyChanged,
                disabled: isNewPatient == 0,
                defaultActiveFirstOption: true,
                optionLabelProp: "label",
                optionFilterProp: "label",
                filterOption: function filterOption(input, option) {
                  return option.label.toLowerCase().includes(input.toLowerCase());
                },
                showSearch: true,
                options: companyOptions
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "address",
              children: /*#__PURE__*/_jsx(Input, {
                placeholder: "Adresse",
                disabled: isNewPatient == 0,
                prefix: /*#__PURE__*/_jsx(GeoAltFill, {})
              })
            })
          })]
        }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            loading: isFormLoading,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Enregistrer"
            })
          })
        })]
      })]
    }), patient && depositAmount && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(CheckCircleFill, {
            size: 30
          }), " RECU"]
        }),
        width: "280px",
        open: showReceipt,
        onClose: function onClose() {
          setShowReceipt(false);
        },
        destroyOnClose: true,
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          ref: ref,
          style: {
            textAlign: 'center'
          },
          children: /*#__PURE__*/_jsx(HospitalizationDepositReceipt, {
            amount: depositAmount,
            patient: patient
          })
        })
      })
    })]
  });
};

export default Admission;